import { searchAlgoliaClient } from "shared/integrations/algolia/searchAlgoliaClient";

export const searchThemeTagsIndex = searchAlgoliaClient.initIndex(
  process.env.REACT_APP_ALGOLIA_THEME_TAGS_INDEX_NAME ?? "",
);
